import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { gql } from '@apollo/client'
import { VALUATION_PROJECTION_REPORT_QUERY } from '../../../graphql.js'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData } from '../CustomUtils'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import ParameterValues from '../ParameterValues.js'

const VALUATION_PROJECTION_REPORT = gql(VALUATION_PROJECTION_REPORT_QUERY)

export default function ValuationProjectionReport({ location }) {
  console.log('ValuationProjectionReport rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, VALUATION_PROJECTION_REPORT, 'valuationProjectionReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    let resultRows = []
    let baseValueTotal = 0, surgeryTotal = 0, popTotal = 0, suiTotal = 0, protogenTotal = 0, biologicTotal = 0, valueTotal = 0, implantTotal = 0, discountTotal = 0
    for (let i = 0; i < results.reportData.length; i++) {
      const row = []
      row.push(<td style={{ textAlign: 'right'}} key={-1}>{i+1}</td>)
      for (let j = 0; j < results.reportData[i].length - 1; j++) {
        if (j >= 9) {
          switch (j) {
            case 9:
              baseValueTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 10:
              surgeryTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 11:
              popTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 12:
              suiTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 13:
              protogenTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 14:
              biologicTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 15:
              valueTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 16:
              implantTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            case 17:
              discountTotal += parseFloat(results.reportData[i][j].replace(/,/g, ''))*100
              break
            default:
          }
          row.push(<td key={j} align={'right'}>{formatter.format(results.reportData[i][j])}</td>)
        } else {
          row.push(<td key={j} align={'left'}>{results.reportData[i][j]}</td>)
        }
      }
      row.push(<td key={-2} style={{verticalAlign: 'middle', width: 'auto'}}><Link to={`/object/${results.reportData[i][results.reportData[i].length-1]}?source=${location.pathname}${location.search}`}><Button color="primary" size="sm">View</Button></Link></td>)
      resultRows.push(<tr key={i}>{row}</tr>)
    }
    baseValueTotal /= 100
    surgeryTotal /= 100
    popTotal /= 100
    suiTotal /= 100
    protogenTotal /= 100
    biologicTotal /= 100
    valueTotal /= 100
    implantTotal /= 100
    discountTotal /= 100
    const totalRow = []
    totalRow.push(<td colSpan='10' align='right'><b>Total</b></td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(baseValueTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(surgeryTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(popTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(suiTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(protogenTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(biologicTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(valueTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(implantTotal)}</td>)
    totalRow.push(<td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formatter.format(discountTotal)}</td>)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BosSci/valuationProjectionReport/valuation_projection', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered>
          <ReportHeading title={'Valuation Projection Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
            <tr>{totalRow}</tr>
          </tbody>
        </Table>
      </div>
    )
  }
}